import { ModLevel } from "@/models/engineering-models.model";
import { SeverityService } from "@/services/app/severity.service";
import { NgIf } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { TagModule } from "primeng/tag";


@Component({
    selector: 'app-mod-column',
    template: `
    <p-tag *ngIf="value" [value]="value.ModName"
    [severity]="severityService.findModSeverity(value.ModID)"></p-tag>
    `,
    standalone: true,
    imports: [
        TagModule,
        NgIf
    ],
    styles: [
        `
        `
    ]
})

export class ModColumnComponent {
@Input() value: ModLevel | null = null;
severityService = inject(SeverityService);
}